(function() { module.exports = window["wp"]["blocks"]; }());